import {
  premiumShopGetChainShopListBackendPath,
  premiumShopUnmergeBranchBackendPath,
  premiumShopTransferPrimaryBackendPath,
  premiumShopDeactivateBackendPath,
  importFoodyMenuBackendPath,
  nowOchaShopsChangeDeliveryBackendPath,
  extendMembershipUpdateBackenddPath,
  extendMembershipBackenddPath,
} from "routes/advancedFunction/urls";

export const updateWhitelistShopBackendPath = '/backend/advanced_function/shop/setting/feature/update/';
export const shopCheckingBackendPath = '/backend/advanced_function/shop/check/';

export const NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST = 'NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST';
export const NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_LOADING = 'NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_LOADING';
export const NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_SUCCESS = 'NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_SUCCESS';
export const NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_FAILURE = 'NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_FAILURE';

export const PREMIUM_SHOP_GET_CHAIN_SHOP_LIST = 'PREMIUM_SHOP_GET_CHAIN_SHOP_LIST';
export const PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_SUCCESS = 'PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_SUCCESS';
export const PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_FAILURE = 'PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_FAILURE';

export const PREMIUM_SHOP_UNMERGE_SHOP = 'PREMIUM_SHOP_UNMERGE_SHOP';
export const PREMIUM_SHOP_UNMERGE_SHOP_SUCCESS = 'PREMIUM_SHOP_UNMERGE_SHOP_SUCCESS';
export const PREMIUM_SHOP_UNMERGE_SHOP_FAILURE = 'PREMIUM_SHOP_UNMERGE_SHOP_FAILURE';

export const PREMIUM_SHOP_TRANSFER_PRIMARY = 'PREMIUM_SHOP_TRANSFER_PRIMARY';
export const PREMIUM_SHOP_TRANSFER_PRIMARY_SUCCESS = 'PREMIUM_SHOP_TRANSFER_PRIMARY_SUCCESS';
export const PREMIUM_SHOP_TRANSFER_PRIMARY_FAILURE = 'PREMIUM_SHOP_TRANSFER_PRIMARY_FAILURE';

export const PREMIUM_SHOP_DEACTIVATE = 'PREMIUM_SHOP_DEACTIVATE';
export const PREMIUM_SHOP_DEACTIVATE_SUCCESS = 'PREMIUM_SHOP_DEACTIVATE_SUCCESS';
export const PREMIUM_SHOP_DEACTIVATE_FAILURE = 'PREMIUM_SHOP_DEACTIVATE_FAILURE';

export const UPDATE_SWITCH_FUNCTION_WHITELIST = 'UPDATE_SWITCH_FUNCTION_WHITELIST';
export const UPDATE_SWITCH_FUNCTION_WHITELIST_LOADING = 'UPDATE_SWITCH_FUNCTION_WHITELIST_LOADING';
export const UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS = 'UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS';
export const UPDATE_SWITCH_FUNCTION_WHITELIST_FAILURE = 'UPDATE_SWITCH_FUNCTION_WHITELIST_FAILURE';
export const UPDATE_SWITCH_FUNCTION_WHITELIST_CLEAR = 'UPDATE_SWITCH_FUNCTION_WHITELIST_CLEAR';

export const SWITCH_FUNCTION_SHOP_CHECKING = 'SWITCH_FUNCTION_SHOP_CHECKING';
export const SWITCH_FUNCTION_SHOP_CHECKING_LOADING = 'SWITCH_FUNCTION_SHOP_CHECKING_LOADING';
export const SWITCH_FUNCTION_SHOP_CHECKING_SUCCESS = 'SWITCH_FUNCTION_SHOP_CHECKING_SUCCESS';
export const SWITCH_FUNCTION_SHOP_CHECKING_FAILURE = 'SWITCH_FUNCTION_SHOP_CHECKING_FAILURE';
export const SWITCH_FUNCTION_SHOP_CHECKING_CLEAR = 'SWITCH_FUNCTION_SHOP_CHECKING_CLEAR';

export const IMPORT_FOODY_MENU_INTO_OCHA = 'IMPORT_FOODY_MENU_INTO_OCHA';
export const IMPORT_FOODY_MENU_INTO_OCHA_SUCCESS = 'IMPORT_FOODY_MENU_INTO_OCHA_SUCCESS';
export const IMPORT_FOODY_MENU_INTO_OCHA_FAILURE = 'IMPORT_FOODY_MENU_INTO_OCHA_FAILURE';

export const EXTEND_MEMBERSHIP_UPDATE = 'EXTEND_MEMBERSHIP_UPDATE';
export const EXTEND_MEMBERSHIP_GET = 'EXTEND_MEMBERSHIP_GET';
export const EXTEND_MEMBERSHIP_UPDATE_SUCCESS = 'EXTEND_MEMBERSHIP_UPDATE_SUCCESS';
export const EXTEND_MEMBERSHIP_UPDATE_FAILURE = 'EXTEND_MEMBERSHIP_UPDATE_FAILURE';

export const importFoodyMenuToOcha = (data, cancelPrevious = true) => ({
  type: IMPORT_FOODY_MENU_INTO_OCHA,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: importFoodyMenuBackendPath, cancelPrevious }
});

export const updateSwitchFunctionWhitelist = (data, cancelPrevious = true) => ({
  type: UPDATE_SWITCH_FUNCTION_WHITELIST,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: updateWhitelistShopBackendPath, cancelPrevious }
});

export const clearStateUpdateSwitchFunctionWhitelist = () => ({
  type: UPDATE_SWITCH_FUNCTION_WHITELIST_CLEAR
});

export const shopChecking = (data, cancelPrevious = true) => ({
  type: SWITCH_FUNCTION_SHOP_CHECKING,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: shopCheckingBackendPath, cancelPrevious }
});

export const clearShopCheckingData = () => ({
  type: SWITCH_FUNCTION_SHOP_CHECKING_CLEAR
});

export const getChainShopList = (primaryShopId, cancelPrevious = true) => ({
  type: PREMIUM_SHOP_GET_CHAIN_SHOP_LIST,
  payload: {primary_shop_id: primaryShopId},
  meta: { httpMethod: 'GET', apiPath: premiumShopGetChainShopListBackendPath, cancelPrevious},
});

export const unmergeShop = (data, cancelPrevious = true) => ({
  type: PREMIUM_SHOP_UNMERGE_SHOP,
  payload: {data},
  meta: { httpMethod: 'POST', apiPath: premiumShopUnmergeBranchBackendPath, cancelPrevious},
});

export const transferPrimary = (data, cancelPrevious = true) => ({
  type: PREMIUM_SHOP_TRANSFER_PRIMARY,
  payload: {data},
  meta: { httpMethod: 'POST', apiPath: premiumShopTransferPrimaryBackendPath, cancelPrevious},
});

export const deactivate = (data, cancelPrevious = true) => ({
  type: PREMIUM_SHOP_DEACTIVATE,
  payload: {data},
  meta: { httpMethod: 'POST', apiPath: premiumShopDeactivateBackendPath, cancelPrevious},
});

export const changeDeliveryStatusRequest = (data, cancelPrevious = true) => ({
  type: NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: nowOchaShopsChangeDeliveryBackendPath, cancelPrevious }
});

export const extendMembershipUpdate = (data, cancelPrevious = true) => ({
  type: EXTEND_MEMBERSHIP_UPDATE,
  payload: {data},
  meta: { httpMethod: 'POST', apiPath: extendMembershipUpdateBackenddPath, cancelPrevious},
});

export const extendMembershipGet = (data, cancelPrevious = true) => ({
  type: EXTEND_MEMBERSHIP_GET,
  payload: {data},
  meta: { httpMethod: 'GET', apiPath: extendMembershipBackenddPath, cancelPrevious},
});


// WEBPACK FOOTER //
// ./src/actions/advancedFunction/index.js